var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_66779",
    "data-name": "Group 66779",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.613,
    height: 18.041,
    viewBox: "0 0 33.613 18.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66777",
    "data-name": "Group 66777",
    transform: "translate(0 6.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110809",
    "data-name": "Path 110809",
    d: "M35.787,17.906A2.307,2.307,0,1,1,33.48,15.6a2.307,2.307,0,0,1,2.307,2.307",
    transform: "translate(-16.174 -15.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110810",
    "data-name": "Path 110810",
    d: "M51.386,17.906A2.307,2.307,0,1,1,49.08,15.6a2.307,2.307,0,0,1,2.307,2.307",
    transform: "translate(-24.773 -15.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110811",
    "data-name": "Path 110811",
    d: "M66.985,17.906A2.307,2.307,0,1,1,64.679,15.6a2.307,2.307,0,0,1,2.307,2.307",
    transform: "translate(-33.372 -15.6)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66778",
    "data-name": "Group 66778",
    transform: "translate(22 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110813",
    "data-name": "Path 110813",
    d: "M49.08,35.812a2.307,2.307,0,1,1,2.307-2.307,2.307,2.307,0,0,1-2.307,2.307",
    transform: "translate(-46.773 -17.771)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8f3ce98974c3729b6f021a640c7baa23.svg";
export { ForwardRef as ReactComponent };